
const state = {
  appDrawer: false,
  errors: [],
  loading: 0
}

export default state